import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';
import { roleGuard } from './core/guards/role.guard';
import { Login } from './features/auth/login';
import { VerifyOtp } from './features/auth/verify-otp';
import { ChangePassword } from './features/auth/change-password';
import { QueueList } from './features/queue/queue-list';
import { TransactionDetail } from './features/transaction-detail';
import { StaffList } from './features/staff/staff-list';
import { StaffCreate } from './features/staff/staff-create';
import { Shell } from './shared/layout/shell';

export const routes: Routes = [
  { path: 'login', component: Login, canActivate: [guestGuard] },
  { path: 'verify-otp', component: VerifyOtp, canActivate: [guestGuard] },
  { path: 'change-password', component: ChangePassword, canActivate: [authGuard] },
  {
    path: '',
    component: Shell,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'queue', pathMatch: 'full' },
      { path: 'queue', component: QueueList },
      { path: 'transactions/:controlReference', component: TransactionDetail },
      {
        path: 'staff',
        component: StaffList,
        canActivate: [roleGuard],
        data: { allowedRoles: ['ADMIN'] },
      },
      {
        path: 'staff/new',
        component: StaffCreate,
        canActivate: [roleGuard],
        data: { allowedRoles: ['ADMIN'] },
      },
    ],
  },
  { path: '**', redirectTo: 'queue' },
];
